import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button, Autocomplete, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import '../../../../AgGridStyle.css';
import HomeIcon from '@mui/icons-material/Home';
import FollowTheSignsIcon from '@mui/icons-material/FollowTheSigns';
import TicketDetailsPopup from './TktDetailsPopup';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { AccessAlarm, Done, PriorityHigh, AccessTime, WarningAmber } from '@mui/icons-material';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const paginationMobileStyles = `
  @media (max-width: 600px) {
    /* Parent container: column layout, center all items */
    .ag-theme-alpine .ag-paging-panel {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;      /* center children horizontally */
      gap: 12px !important;
      padding: 12px !important;
      min-height: 100px;
      box-sizing: border-box;
      text-align: center;
    }

    /* Wrapper flex container for Total Records + Page Size */
    .ag-theme-alpine .ag-paging-row-summary-panel,
    .ag-theme-alpine .ag-paging-page-size {
      display: inline-flex !important;
      align-items: center;
      gap: 16px;
      font-size: 14px;
      white-space: nowrap;               /* prevent wrapping */
      justify-content: center;
      margin: 0 !important;
    }

    /* Put Total Records and Page Size side-by-side in one row */
    .ag-theme-alpine .ag-paging-panel > .ag-paging-row-summary-panel,
    .ag-theme-alpine .ag-paging-panel > .ag-paging-page-size {
      flex: none;
    }

    /* Buttons below, centered */
    .ag-theme-alpine .ag-paging-button-panel {
      width: 100%;
      display: flex !important;
      justify-content: center !important;
      flex-wrap: wrap;
      margin-top: 8px;
    }

    /* Page-size dropdown/input */
    .ag-theme-alpine .ag-paging-page-size select,
    .ag-theme-alpine .ag-paging-page-size input {
      max-width: 70px !important;
      font-size: 14px !important;
      padding: 4px;
    }
  }
`;

const TicketReport = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);

    const today = dayjs();
    
        let startYear, endYear;
    
        if (today.month() >= 3) {
            startYear = today.year();
            endYear = today.year() + 1;
        } else {
            startYear = today.year() - 1;
            endYear = today.year();
        }

    const [dateFrom, setDateFrom] = useState(dayjs(`${startYear}-04-01`));
    const [dateTo, setDateTo] = useState(dayjs(`${endYear}-04-01`).subtract(1, 'day'));
    const [raisedBy, setRaisedBy] = useState([]);
    const [status, setStatus] = useState('');
    const [formData, setFormData] = useState({
        SelectedId: '',
    });
    const [priorityFilter, setPriorityFilter] = useState(null);
    const [filteredPriority, setfilterPriority] = useState('');
    const [radioValue, setRadioValue] = useState('C');
    const [displayData, setDisplayData] = useState([]);

    const statusOptions = ['All', 'O', 'I', 'H', 'R', 'C'];
    const statusFullNames = {
        'All': 'All',
        'O': 'Open',
        'I': 'In-progress',
        'H': 'Hold',
        'R': 'Resolved',
        'C': 'Canceled',
    };

    

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = paginationMobileStyles;
        document.head.appendChild(style);

        return () => document.head.removeChild(style);
    }, []);

    const colDefs = useMemo(() => [
        { field: 'RowNum', headerName: 'Sr.No', width: 70 },
        { field: 'TicketNo', headerName: 'Ticket No', width: 90 },
        {
            field: 'TktDate',
            headerName: 'Ticket Date',
            width: 130,
            filter: 'agTextColumnFilter',
            filterParams: {
                filterOptions: ['contains', 'equals'],
                debounceMs: 300,
            },
            valueFormatter: (params) => {
                if (!params.value) return '';
                const d = new Date(params.value);
                return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
            },
        },
        {
            field: 'TktDate',
            headerName: 'Start Time',
            width: 110,
            valueGetter: (params) => {
                if (!params.data?.TktDate) return '';
                const d = new Date(params.data.TktDate);
                return d.toLocaleTimeString('en-GB', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                });
            },
            cellStyle: { fontFamily: 'monospace' },
        },
        {
            field: 'EndDate',
            headerName: 'End Time',
            width: 150,
            filter: 'agDateColumnFilter',
            valueFormatter: (params) => {
                if (!params.value || dayjs(params.value).isSame('1900-01-01', 'day')) return '';
                const formattedDate = dayjs(params.value).format('DD/MM/YYYY HH:mm:ss');
                return formattedDate;
            },
        },
        { field: 'PropName', headerName: 'Property', width: 200 },
        { field: 'Name', headerName: 'RaisedBy', width: 100 },
        { field: 'UpdatedName', headerName: 'Resolved By', width: 100 },
        { field: 'RoomBedName', headerName: 'RoomBed', width: 80 },
        { field: 'ServiceName', headerName: 'Service/Complain', width: 200 },
        { field: 'MobileNo', headerName: 'Mobile', width: 100 },
        { field: 'CategoryName', headerName: 'Category', width: 130 },
        { field: 'SubCategoryName', headerName: 'SubCategory', width: 140 },
        { field: 'TotalCost', headerName: 'MatCost', width: 80 },
        {
            field: 'LeadTime',
            headerName: 'LeadTime',
            width: 100,
            valueFormatter: (params) => {
                if (!params.value) return '';

                const cleanValue = params.value.trim();

                const hoursMatch = cleanValue.match(/(\d+(\.\d+)?)\s*Hr/);
                const minutesMatch = cleanValue.match(/(\d+(\.\d+)?)\s*Min/);

                let formattedLeadTime = '';

                if (hoursMatch) {
                    const hours = parseFloat(hoursMatch[1]);
                    formattedLeadTime += hours.toFixed(2) + " Hr";
                }

                if (minutesMatch) {
                    const minutes = parseFloat(minutesMatch[1]);
                    formattedLeadTime += " " + minutes.toFixed(2) + " Min";
                }
                return formattedLeadTime || '';
            },
        },
        { field: 'DelayTime', headerName: 'DelayTime', width: 100 },
        {
            field: 'TicketServName',
            headerName: 'Priority',
            width: 100,
            cellStyle: (params) => {
                let backgroundColor = 'transparent';
                let color = 'white';

                switch (params.value) {
                    case 'High':
                        backgroundColor = 'red';
                        break;
                    case 'Low':
                        backgroundColor = '#8c8546';
                        break;
                    case 'Medium':
                        backgroundColor = 'orange';
                        break;
                    case 'Critical':
                        backgroundColor = 'purple';
                        break;
                    default:
                        backgroundColor = '#f0f0f0';
                        break;
                }

                return {
                    backgroundColor,
                    color
                };
            },
            cellRenderer: (params) => {
                let statusText = '';
                switch (params.value) {
                    case 'High':
                        statusText = 'High';
                        break;
                    case 'Low':
                        statusText = 'Low';
                        break;
                    case 'Medium':
                        statusText = 'Medium';
                        break;
                    case 'Critical':
                        statusText = 'Critical';
                        break;
                    default:
                        statusText = 'Unknown';
                        break;
                }

                return <span style={{ fontWeight: 'bold' }}>{statusText}</span>;
            },
        },
        {
            field: 'TicketSt',
            headerName: 'Ticket Status',
            width: 100,
            cellRenderer: (params) => {
                let statusText = '';
                let statusColor = 'black';
                switch (params.value) {
                    case 'O':
                        statusText = 'Open';
                        statusColor = 'green';
                        break;
                    case 'I':
                        statusText = 'In Progress';
                        statusColor = '#d47b0dff';
                        break;
                    case 'C':
                        statusText = 'Canceled';
                        statusColor = '#8B0000';
                        break;
                    case 'R':
                        statusText = 'Resolved';
                        statusColor = '#008080';
                        break;
                    case 'H':
                        statusText = 'Hold';
                        statusColor = '#800080';
                        break;
                    default:
                        statusText = 'Unknown';
                        statusColor = 'gray';
                        break;
                }
                return (
                    <span style={{ color: statusColor, fontWeight: 'bold' }}>
                        {statusText}
                    </span>
                );
            },
        },
        { field: 'FloorName', headerName: 'Floor', width: 80 },
        { field: 'CommonAreaName', headerName: 'Common Area', width: 120 },
        { field: 'AmenityName', headerName: 'Amenity', width: 110 },
        { field: 'Description', headerName: 'Description', width: 110 },
        { field: 'ResRemark', headerName: 'Resolve Remark', width: 110 },
        { field: 'Remark', headerName: 'Remark', width: 110 },
    ], []);

    // const getRowStyle = (params) => {
    //     if (params.data.TicketServName === 'High') {
    //         return { backgroundColor: '#f4b6b6' };
    //     }
    //     else if (params.data.TicketServName === 'Low') {
    //         return { backgroundColor: '#f5f1a8' };
    //     }
    //     else if (params.data.TicketServName === 'Medium') {
    //         return { backgroundColor: '#f6c27a' };
    //     }
    //     else if (params.data.TicketServName === 'Critical') {
    //         return { backgroundColor: '#cfa6f2' };
    //     }
    //     return {};
    // };

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    useEffect(() => {
        fetchTickets();
        fetchRaisedBy();
    }, [globalProperty]);

    const fetchTickets = async () => {
        try {
            setIsLoading(true);

            const raisedById = formData.SelectedId || 1;
            const statusValue = status === 'All' ? '' : status;

            let endpointFlag = "TicketDash";
            if (radioValue === 'R') {
                endpointFlag = "ByResolveDate";
            }

            const response = await axiosInstance.post("TrnTicketing/GetFilterTicketDashBoard", {
                PageNumber: 1,
                PageSize: 10,
                PropId: globalProperty,
                Id: 1,
                WardenId: raisedById,
                ServiceProvId: 1,
                SearchText: statusValue,
                SearchFrom: dateFrom.format('YYYY-MM-DD'),
                SearchTo: dateTo.format('YYYY-MM-DD'),
                Flag: endpointFlag,
            });

            const { data: { Status, Data } } = response;

            if (Status === 0 && Array.isArray(Data)) {
                setDisplayData(Data);
                setPriorityFilter(Data);
            } else {
                setDisplayData([]);
                setPriorityFilter([]);
            }
        } catch (error) {
            toast.error("Error fetching tickets");
            setDisplayData([]);
            setPriorityFilter([]);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchRaisedBy = async () => {
        try {
            const response = await axiosInstance.post("TrnTicketing/getPropertyWisedrp", {
                PropId: globalProperty,
                Flag: "RaisedBy"
            });
            if (response.data.Status === 0) {
                setRaisedBy(response.data.Data);
            } else {
                setRaisedBy([]);
            }
        } catch (error) {
            toast.error("Error while fetching raised by.");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const onGridReady = useCallback((params) => {
        // No sizeColumnsToFit here to preserve flex sizing
    }, []);

    const handleRowDoubleClick = useCallback((params) => {
        setSelectedTicket(params.data);
        setPopupOpen(true);
    }, []);

    const handleRowClick = useCallback((params) => {
        setSelectedTicket(params.data);
        setPopupOpen(true);
    }, []);

    const handleClearFilters = () => {
        gridRef.current?.api?.setFilterModel(null);
        setfilterPriority('');
        setPriorityFilter('');
    };

    const applyPriorityFilter = (priority) => {
        setPriorityFilter(priority);

        const currentData = displayData;

        if (priority === 'High') {
            setfilterPriority(currentData.filter(ticket => ticket.TicketServName === 'High'));
        } else if (priority === 'Low') {
            setfilterPriority(currentData.filter(ticket => ticket.TicketServName === 'Low'));
        } else if (priority === 'Medium') {
            setfilterPriority(currentData.filter(ticket => ticket.TicketServName === 'Medium'));
        } else if (priority === 'On Time') {
            setfilterPriority(currentData.filter(ticket => ticket.DelayTime === 'On Time'));
        } else if (priority === 'Delay') {
            setfilterPriority(currentData.filter(ticket => ticket.DelayTime === 'Delay'));
        } else {
            setfilterPriority(currentData);
        }
    };

    const importToExcel = async () => {
        if (!displayData || displayData.length === 0) {
            toast.info("No data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Tickets');

        // ==================== Light Blue Border Definition ====================
        const lightBlueBorder = {
            top: { style: 'thin', color: { argb: 'FF81C4FF' } },
            left: { style: 'thin', color: { argb: 'FF81C4FF' } },
            bottom: { style: 'thin', color: { argb: 'FF81C4FF' } },
            right: { style: 'thin', color: { argb: 'FF81C4FF' } }
        };

        // ==================== COLUMN DEFINITION ====================
        worksheet.columns = [
            { header: 'Sr. No', key: 'RowNum', width: 10 },
            { header: 'Ticket No', key: 'TicketNo', width: 15 },
            { header: 'Ticket Date', key: 'TktDate', width: 20 },
            { header: 'Property', key: 'PropName', width: 20 },
            { header: 'Service', key: 'ServiceName', width: 20 },
            { header: 'Mobile', key: 'MobileNo', width: 15 },
            { header: 'Raised By', key: 'Name', width: 20 },
            { header: 'Category', key: 'CategoryName', width: 18 },
            { header: 'Sub Category', key: 'SubCategoryName', width: 18 },
            { header: 'Mat Cost', key: 'TotalCost', width: 14 },
            { header: 'Lead Time', key: 'LeadTime', width: 12 },
            { header: 'Delay Time', key: 'DelayTime', width: 12 },
            { header: 'End Date', key: 'EndDate', width: 20 },
            { header: 'Priority', key: 'TicketServName', width: 14 },
            { header: 'Status', key: 'TicketSt', width: 14 },
            { header: 'Room/Bed', key: 'RoomBedName', width: 14 },
            { header: 'Floor', key: 'FloorName', width: 12 },
            { header: 'Common Area', key: 'CommonAreaName', width: 18 },
            { header: 'Amenity', key: 'AmenityName', width: 18 },
            { header: 'Description', key: 'Description', width: 25 },
            { header: 'Resolve Remark', key: 'ResRemark', width: 25 },
            { header: 'Remark', key: 'Remark', width: 25 },
        ];

        // ==================== ADD DATA ROWS ====================
        displayData.forEach((ticket, index) => {
            const row = worksheet.addRow({
                RowNum: index + 1,
                TicketNo: ticket.TicketNo || '',
                TktDate: ticket.TktDate ? dayjs(ticket.TktDate).format('DD-MM-YYYY HH:mm') : '',
                PropName: ticket.PropName || '',
                ServiceName: ticket.ServiceName || '',
                MobileNo: ticket.MobileNo || '',
                Name: ticket.Name || '',
                CategoryName: ticket.CategoryName || '',
                SubCategoryName: ticket.SubCategoryName || '',
                TotalCost: Number(ticket.TotalCost || 0),
                LeadTime: ticket.LeadTime || '',
                DelayTime: ticket.DelayTime || '',
                EndDate: ticket.EndDate ? dayjs(ticket.EndDate).format('DD-MM-YYYY HH:mm') : '',
                TicketServName: ticket.TicketServName || '',
                TicketSt: ticket.TicketSt || '',
                RoomBedName: ticket.RoomBedName || '',
                FloorName: ticket.FloorName || '',
                CommonAreaName: ticket.CommonAreaName || '',
                AmenityName: ticket.AmenityName || '',
                Description: ticket.Description || '',
                ResRemark: ticket.ResRemark || '',
                Remark: ticket.Remark || ''
            });

            // Alternate row coloring with light gray + Light Blue Border
            row.eachCell((cell) => {
                if (index % 2 === 0) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
                }
                cell.border = lightBlueBorder;
            });

            // Right align numeric columns (Mat Cost)
            const costCell = row.getCell('TotalCost');
            if (costCell.value) {
                costCell.numFmt = '#,##0';
                costCell.alignment = { horizontal: 'right' };
            }
        });

        // ==================== STYLE HEADER ROW ====================
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '635BFF' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = lightBlueBorder;
        });

        headerRow.height = 24;

        // ==================== EXPORT ====================
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, 'Ticket_Report.xlsx');
    };

    const handleRadioChange = (e) => {
        setRadioValue(e.target.value);
    };

    return (
        <Box
            sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/service&ticket/complaint')}
                    >
                        Ticket
                    </Link>

                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Ticket Report
                    </Typography>
                </Breadcrumbs>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: { xs: 1, sm: 1, md: 0 },
                        flexShrink: 0,
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="From-Date"
                            value={dateFrom}
                            onChange={(newValue) => setDateFrom(newValue)}
                            format="DD/MM/YYYY"
                            sx={{
                                width: 150,
                                '& .MuiInputBase-input': {
                                    padding: '7px 10px !important',
                                },
                            }}
                        />
                        <DatePicker
                            label="To-Date"
                            value={dateTo}
                            onChange={(newValue) => setDateTo(newValue)}
                            format="DD/MM/YYYY"
                            sx={{
                                width: 150,
                                '& .MuiInputBase-input': {
                                    padding: '7px 10px !important',
                                },
                            }}
                        />
                    </LocalizationProvider>

                    <Autocomplete
                        options={raisedBy}
                        getOptionLabel={(option) => option.Name}
                        value={raisedBy.find((itm) => itm.Id === formData.SelectedId) || null}
                        onChange={(event, newValue) => {
                            handleInputChange({
                                target: { name: "SelectedId", value: newValue ? newValue.Id : "" },
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="RaisedBy"
                                variant="filled"
                                className="custom-textfield"
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                        sx={{ width: "200px" }}
                    />

                    <Autocomplete
                        value={status || null}
                        onChange={(event, newValue) => {
                            if (newValue === null || statusOptions.includes(newValue)) {
                                setStatus(newValue || '');
                            }
                        }}
                        options={statusOptions}
                        getOptionLabel={(option) => statusFullNames[option] || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Status"
                                variant="filled"
                                className="custom-textfield"
                            />
                        )}
                        sx={{ width: "200px" }}
                    />

                    <Tooltip title='Click to retreive data' arrow>
                        <Button
                            variant='contained'
                            onClick={fetchTickets}
                            sx={{
                                borderRadius: '8px', backgroundColor: '#635bff', '&:hover': {
                                    backgroundColor: '#635bff',
                                },
                            }}
                        >
                            Get Data
                        </Button>
                    </Tooltip>

                    <Tooltip title="Export to Excel" arrow>
                        <Button
                            startIcon={<ImportExportIcon />}
                            variant="contained"
                            onClick={importToExcel}
                            sx={{
                                borderRadius: '8px',
                                backgroundColor: '#4caf50',
                                '&:hover': {
                                    backgroundColor: '#4caf50',
                                },
                            }}
                        >
                            Excel
                        </Button>
                    </Tooltip>

                    <Tooltip title='Clear all applied filter' arrow>
                        <Button
                            variant="outlined"
                            onClick={handleClearFilters}
                            sx={{
                                borderRadius: "50px",
                                textTransform: "none",
                                borderColor: "#635bff",
                                color: "#635bff",
                                "&:hover": {
                                    borderColor: "#524ccc",
                                    backgroundColor: "rgba(99, 91, 255, 0.04)",
                                }
                            }}
                        >
                            Clear
                        </Button>
                    </Tooltip>

                    <Tooltip title='Back' arrow>
                        <Box sx={{
                            display: "flex", alignItems: "center", gap: 1,
                            justifyContent: "flex-start"
                        }}
                        >
                            <IconButton
                                onClick={() => navigate('/service&ticket/complaint')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "#ffffff",
                    flexWrap: "wrap",
                    maxWidth: "95%",
                    margin: '0 auto',
                    mb: 1
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        marginLeft: "auto",
                    }}
                >
                    <FormControl>
                        <Box display="flex" alignItems="center" gap={2}>
                            <FormLabel id="demo-row-radio-buttons-group-label" sx={{ color: '#635bff', fontWeight: 'bold' }}>Filter By Date</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={radioValue}
                                onChange={handleRadioChange}
                            >
                                <FormControlLabel value="C" control={<Radio />} label="Created" />
                                <FormControlLabel value="R" control={<Radio />} label="Resolved" />
                            </RadioGroup>
                        </Box>
                    </FormControl>

                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<PriorityHigh />}
                        onClick={() => applyPriorityFilter('High')}
                        sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            padding: "6px 16px",
                            '&:hover': {
                                backgroundColor: "rgba(244, 67, 54, 0.1)",
                                borderColor: "#f44336",
                            },
                        }}
                    >
                        High
                    </Button>

                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<AccessAlarm />}
                        onClick={() => applyPriorityFilter('Low')}
                        sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            padding: "6px 16px",
                            '&:hover': {
                                backgroundColor: "rgba(156, 39, 176, 0.1)",
                                borderColor: "#9c27b0",
                            },
                        }}
                    >
                        Low
                    </Button>

                    <Button
                        variant="outlined"
                        color="warning"
                        startIcon={<WarningAmber />}
                        onClick={() => applyPriorityFilter('Medium')}
                        sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            padding: "6px 16px",
                            '&:hover': {
                                backgroundColor: "rgba(255, 193, 7, 0.1)",
                                borderColor: "#ffeb3b",
                            },
                        }}
                    >
                        Medium
                    </Button>

                    <Button
                        variant="outlined"
                        color="success"
                        startIcon={<Done />}
                        onClick={() => applyPriorityFilter('On Time')}
                        sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            padding: "6px 16px",
                            '&:hover': {
                                backgroundColor: "rgba(17, 54, 8, 0.1)",
                                borderColor: "#315c35",
                            },
                        }}
                    >
                        On Time
                    </Button>

                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<AccessTime />}
                        onClick={() => applyPriorityFilter('Delay')}
                        sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            padding: "6px 16px",
                            '&:hover': {
                                backgroundColor: "rgba(33, 150, 243, 0.1)",
                                borderColor: "#2196f3",
                            },
                        }}
                    >
                        Delay
                    </Button>

                    <Tooltip title='Check Ticket Follow up' arrow>
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<FollowTheSignsIcon />}
                            onClick={() => navigate('/ticketfollow')}
                            sx={{
                                borderRadius: "50px",
                                textTransform: "none",
                                padding: "6px 16px",
                                '&:hover': {
                                    backgroundColor: "rgba(33, 150, 243, 0.1)",
                                    borderColor: "#2196f3",
                                },
                            }}
                        >
                            Follow
                        </Button>
                    </Tooltip>
                </Box>
            </Box>

            <Box className="table-grid ag-theme-alpine"
                sx={{ height: 'calc(85% - 56px)', width: '95%', margin: '0 auto', position: 'relative' }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />

                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        // rowData={filteredPriority.length > 0 ? filteredPriority : rowData}
                        rowData={filteredPriority?.length > 0 ? filteredPriority : displayData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={1000}
                        onRowDoubleClicked={handleRowDoubleClick}
                        onRowClicked={handleRowClick}
                        paginationPageSizeSelector={[500, 1000, 5000, 10000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={25}
                        headerHeight={30}
                        floatingFiltersHeight={28}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No rows to show</span>'}
                        tooltipShowDelay={0}
                    // getRowStyle={getRowStyle}
                    />
                )}
            </Box>
            <Box sx={{
                position: 'absolute',
                bottom: 46,
                left: 70,
                fontSize: '14px',
                color: 'black',
                display: { xs: 'none', sm: 'none', md: 'block' },
            }}>
                Total Records: <b>{displayData.length}</b>
            </Box>
            <TicketDetailsPopup
                open={popupOpen}
                onClose={() => setPopupOpen(false)}
                ticket={selectedTicket}
            />
        </Box>
    );
};

export default TicketReport;
